import { Fragment, useEffect, useRef, useState } from "react";
import Inputs from "../views/html/Inputs";
import { Labels } from "../views/html/Labels";
import { userContext } from "../views/html/FormComponent";
import { useContext } from "react";
import { jsonPostSlider } from "./FormDataSlider";
import { getMessage } from "../../utils/getMessage";

export const InputsComponent = (props) => {
  const { questions, encuestaNueva } = props;
  const {
    slides,
    preguntaXSlide,
    showSendButton,
    setShowSendButton,
    currentPage,
    setmsgAlert,
    setAlertCaptcha,
    showCaptcha,
    canal,
    msgAlert,
    valueCatcha,
    showAlert,
    setShowAlert,
    setCurrentPage,
    parametrosURL,
  } = useContext(userContext);
  //Esta pregunta es padre de la que fue respondida en el componente <Inputs />
  const [accumulativeIdQuestions, setAccumulativeIdQuestions] = useState([]);
  const [singleIdQuestion, setSingleIdQuestion] = useState();
  const [min, setMin] = useState(1);
  const [max, setMax] = useState(min + preguntaXSlide);
  const next = useRef(null);
  //const [accumulativeIdQuestions, setAccumulativeIdQuestions] = useState(null);
  const showQuestion = useRef(null);
  //console.log(showAlert, msgAlert)

  useEffect(() => {
    max > questions.length && setShowSendButton(true);
    slides && max <= questions.length && setShowSendButton(false);
  }, [max, questions, setShowSendButton, slides]);

  // useEffect(() => {
  //   if (showAlert && slides) {
  //     setmsgAlert(true);
  //   }
  // }, [showAlert, slides, showCaptcha]);

  const previousSlide = (e) => {
    e.preventDefault();
    setMin(min - preguntaXSlide);
    setMax(max - preguntaXSlide);
    setCurrentPage(currentPage - 1);
  };

  const nextSlide = (e) => {
    e.preventDefault();
    validFormSlider({ responses: jsonPostSlider(e) });
    if (next.current) {
      setMax(max + preguntaXSlide);
      setMin(min + preguntaXSlide);
      setCurrentPage(currentPage + 1);
    }
  };

  const validFormSlider = (formData) => {
    const { responses } = formData;
    console.log("response:", responses);
    console.log("questions:", questions);
    let flag = false;

    for (const q of questions) {
      if (q.PreguntaNro >= min && q.PreguntaNro < max) {
        if (
          q.PreguntaObligatoria &&
          !responses.some((res) => q.PreguntaId == res.IdPregunta)
        ) {
          //Se suben las líneas de código 83 a 86 arriba para que valide directamente las respuestas sin verificar preguntas padre o hijas, ya que en slide no existe ese concepto
          // next.current = false;
          // flag = true;
          // setmsgAlert(true);
          // break;
          const objFiltered = questions.filter((q) => q.PreguntaIdPadre != 0);
          //Si la pregunta no respondida es normal, osea que no es padre ni hija de nadie
          if (objFiltered.every((obj) => q.PreguntaId != obj.PreguntaId)) {
            console.log('normal no respondida', q.PreguntaId)
            next.current = false;
            flag = true;
            setmsgAlert(true);
            break;
          } else {
            //Si la pregunta no respondida es hija y fue mostrada en pantalla
            if (responses.some((res) => q.PreguntaId == res.subPreguntaId)) {
              console.log('normal no respondida2', q.PreguntaId)
              flag = true;
              setmsgAlert(true);
              next.current = false;
              break;
            } else {
              //Si la pregunta no respondida es hija pero no fue mostrada en pantalla
            }
          }
        } else {
          //Pregunta respondida
          //console.log('pregunta normal respondida',q.PreguntaId)
          next.current = true;
        }
      }
    }

    // questions.forEach((q) => {
    //   if (q.PreguntaNro >= min && q.PreguntaNro < max) {
    //     if (
    //       q.PreguntaObligatoria &&
    //       !responses.some((res) => q.PreguntaId == res.IdPregunta)
    //     ) {
    //       const objFiltered = questions.filter((q) => q.PreguntaIdPadre != 0);
    //       //Si la pregunta no respondida es normal, osea que no es padre ni hija de nadie
    //       if (objFiltered.every((obj) => q.PreguntaId != obj.PreguntaId)) {
    //         //console.log(min, q.PreguntaNro, max)
    //         next.current = false;
    //         flag = true;
    //         setmsgAlert(true);
    //         //setAlertCaptcha(false);
    //         console.log("normal no respondida");
    //       } else {
    //         //Si la pregunta no respondida es hija y fue mostrada en pantalla
    //         if (responses.some((res) => q.PreguntaId == res.subPreguntaId)) {
    //           flag = true;
    //           setmsgAlert(true);
    //           next.current = true;
    //           console.log("hija no respondida mostrada");
    //           //setAlertCaptcha(false);
    //         } else {
    //           //Si la pregunta no respondida es hija pero no fue mostrada en pantalla
    //           //next.current = true
    //           //flag = false;
    //         }
    //       }
    //     } else {
    //       //Pregunta respondida
    //       next.current = true;
    //       console.log("normal respondida");
    //     }
    //   }
    // });
    setShowAlert(flag);
  };

  //Reemplaza en el texto de la pregunta el @pagina lo que viene por el parámetro pagina de la url. Solo Alpina lo usa
  const replaceText = (text) => {
    if (parametrosURL) {
      const params = new URLSearchParams(window.location.search);
      let pagina = "";
      let canal = "";
      let cliente = "";
      if (params.size > 1) {
        pagina = params.get("pagina");
        canal = params.get("canal");
        cliente = params.get("cliente");
      }
      const replacementMap = {
        // "@cliente": cliente || "ONCOSALUD",
        "@canal": canal || "@canal",
        "@pagina": pagina || "",
      };
      // const regex = new RegExp("@cliente", "g");
      const regex = /@cliente|@canal|@pagina/g;
      //const newTextAlpina = text?.replace("@pagina", pagina ? pagina : "");
      const newText = text?.replace(regex, (match) => replacementMap[match]);
      return newText;
    } else {
      return text;
    }
  };

  //Verifiamos si un padre tiene respuestas
  const theFatherHasAnAnswer = (preguntaIdPadre) => {
    // Buscar el objeto que coincida
    const encontrado = questions.find((q) => q.PreguntaId === preguntaIdPadre);

    // Si no existe retornar false
    if (!encontrado) return false;

    // Validar si RespuestaId es null
    return encontrado.response.length > 0 &&
      encontrado.response[0].RespuestaId != null
      ? true
      : false;
  };
  console.log("accumulativeIdQuestions:", accumulativeIdQuestions);
  if (slides) {
    return (
      <>
        {questions.map((q, index) => {
          let iDpreguntaPadre = null;
          let iDpreguntaHija = null;

          if (q.PreguntaIdPadre !== 0) {
            iDpreguntaPadre = q.PreguntaIdPadre;
            iDpreguntaHija = q.PreguntaId;
            //console.log('distinta a cero', iDpreguntaHija)
            // if(accumulativeIdQuestions.includes(iDpreguntaPadre)) {
            //   showQuestion.current = true;
            // } else {
            //   showQuestion.current = false;
            // }
            //console.log(accumulativeIdQuestions, iDpreguntaHija);
            //console.log(accumulativeIdQuestions)
            //console.log(singleIdQuestion)
            if (
              accumulativeIdQuestions.includes(iDpreguntaHija) ||
              singleIdQuestion == iDpreguntaHija
            ) {
              //console.log('hija mostrada', iDpreguntaHija)
              showQuestion.current = true;
            } else {
              theFatherHasAnAnswer(q.PreguntaIdPadre)
                ? (showQuestion.current = false)
                : (showQuestion.current = true);
            }
          } else {
            //console.log('normal mostrada', iDpreguntaHija)
            showQuestion.current = true;
          }

          return (
            <Fragment key={index}>
              <div
                className={`containerPregunta question-${q.PreguntaNro} ${
                  q.PreguntaNro >= min &&
                  q.PreguntaNro < max &&
                  showQuestion.current
                    ? "show-it"
                    : "hide-it"
                }`}
                key={`con${q.PreguntaId}`}
              >
                <Labels
                  keyNumber={`p${q.PreguntaId}`}
                  texto={replaceText(q.PreguntaTexto)}
                  textoEnriquecido={replaceText(q.PreguntaTextoEnriquecido)}
                  numero={q.PreguntaNro}
                  required={q.PreguntaObligatoria}
                  preguntaId={q.PreguntaId}
                  preguntaHija={iDpreguntaHija}
                />
                <Inputs
                  PreguntaId={q.PreguntaId}
                  response={q.response}
                  questions={questions}
                  accumulativeIdQuestions={accumulativeIdQuestions}
                  idQuestion={setAccumulativeIdQuestions}
                  setSingleIdQuestion={setSingleIdQuestion}
                  encuestaNueva={encuestaNueva}
                />
                {q.PreguntaTextoAdicional && (
                  <div className="texto-adicional">
                    <span>
                      {q.PreguntaTipoTextoAdicional === 1
                        ? getMessage(22)
                        : q.PreguntaTipoTextoAdicional === 2
                        ? getMessage(28)
                        : q.PreguntaTipoTextoAdicional === 3
                        ? getMessage(30)
                        : getMessage(33)}
                    </span>
                    <span>
                      {q.PreguntaTipoTextoAdicional === 1
                        ? getMessage(23)
                        : q.PreguntaTipoTextoAdicional === 2
                        ? getMessage(29)
                        : q.PreguntaTipoTextoAdicional === 3
                        ? getMessage(31)
                        : getMessage(34)}
                    </span>
                  </div>
                )}
              </div>
            </Fragment>
          );
        })}
        <div className="slide-controller">
          <button
            onClick={previousSlide}
            className={`btnSend ${min == 1 ? "hide-button" : "show-button"}`}
          >
            Atrás
          </button>
          <button
            onClick={nextSlide}
            className={`btnSend ${
              max > questions.length ? "hide-button" : "show-button"
            }`}
          >
            Siguiente
          </button>
        </div>
      </>
    );
  } else {
    return (
      <>
        {questions.map((q, index) => {
          let iDpreguntaPadre = null;
          let iDpreguntaHija = null;

          if (q.PreguntaIdPadre !== 0) {
            iDpreguntaPadre = q.PreguntaIdPadre;
            iDpreguntaHija = q.PreguntaId;

            /*
            let padreObj = null;
            questions.forEach((qes) => {
              if (qes.PreguntaId == qes.PreguntaIdPadre) {
                padreObj = qes;
              }
            });
            */

            if (
              accumulativeIdQuestions.includes(iDpreguntaHija) ||
              singleIdQuestion == iDpreguntaHija
            ) {
              showQuestion.current = true;
            } else {
              theFatherHasAnAnswer(q.PreguntaIdPadre)
                ? (showQuestion.current = false)
                : (showQuestion.current = true);
            }
          } else {
            showQuestion.current = true;
          }

          return (
            <Fragment key={index}>
              {showQuestion.current && (
                <div
                  className={`containerPregunta question-${q.PreguntaNro} ${
                    showQuestion.current ? "show-it" : "hide-it"
                  }`}
                  key={`con${q.PreguntaId}`}
                >
                  <Labels
                    keyNumber={`p${q.PreguntaId}`}
                    texto={replaceText(q.PreguntaTexto)}
                    textoEnriquecido={replaceText(q.PreguntaTextoEnriquecido)}
                    numero={q.PreguntaNro}
                    required={q.PreguntaObligatoria}
                    preguntaId={q.PreguntaId}
                    preguntaHija={iDpreguntaHija}
                  />
                  <Inputs
                    PreguntaId={q.PreguntaId}
                    response={q.response}
                    questions={questions}
                    accumulativeIdQuestions={accumulativeIdQuestions}
                    idQuestion={setAccumulativeIdQuestions}
                    setSingleIdQuestion={setSingleIdQuestion}
                    encuestaNueva={encuestaNueva}
                  />
                  {q.PreguntaTextoAdicional && (
                    <div className="texto-adicional">
                      <span>
                        {q.PreguntaTipoTextoAdicional === 1
                          ? getMessage(22)
                          : q.PreguntaTipoTextoAdicional === 2
                          ? getMessage(28)
                          : q.PreguntaTipoTextoAdicional === 3
                          ? getMessage(30)
                          : getMessage(33)}
                      </span>
                      <span>
                        {q.PreguntaTipoTextoAdicional === 1
                          ? getMessage(23)
                          : q.PreguntaTipoTextoAdicional === 2
                          ? getMessage(29)
                          : q.PreguntaTipoTextoAdicional === 3
                          ? getMessage(31)
                          : getMessage(34)}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </Fragment>
          );
        })}
      </>
    );
  }
};
